export default [
  {
    questionType: 'TextInput',
    questionText: 'Telefone de contato',
    questionId: 'telefone',
    placeholderText: 'telefone',
  },
  {
    questionType: 'MultipleSelectionGroup',
    questionTypeOriginal: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Qual o grau de escolaridade do produtor?',
    questionId: 'escolaridade',
    options: [
      {
        optionText: 'ENSINO FUNDAMENTAL INCOMPLETO',
        value: '0',
      },
      {
        optionText: 'ENSINO FUNDAMENTAL COMPLETO',
        value: '1',
      },
      {
        optionText: 'ENSINO MÉDIO INCOMPLETO',
        value: '2',
      },
      {
        optionText: 'ENSINO MÉDIO COMPLETO',
        value: '3',
      },
      {
        optionText: 'ENSINO SUPERIOR INCOMPLETO',
        value: '4',
      },
      {
        optionText: 'ENSINO SUPERIOR COMPLETO',
        value: '5',
      },
      {
        optionText: 'PÓS GRADUADO',
        value: '6',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Tem sucessão familiar na propriedade?',
    questionId: 'sucessao',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'MultipleSelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Tem acesso à internet?',
    questionId: 'internet',
    options: [
      {
        optionText: 'NÃO',
        value: '0',
      },
      {
        optionText: 'PELO CELULAR',
        value: '1',
      },
      {
        optionText: 'PELO COMPUTADOR',
        value: '2',
      },
      {
        optionText: 'PELO CELULAR E COMPUTADOR',
        value: '3',
      },
    ],
  },
  {
    questionType: 'MultipleSelectionGroup',
    questionText: 'Acessa alguma rede social? (Permitido selecionar várias)',
    questionId: 'rede_social',
    questionSettings: {
      autoAdvance: false,
      minMultiSelect: 1,
      maxMultiSelect: 5,
    },
    options: [
      {
        optionText: 'NÃO',
        value: '0',
      },
      {
        optionText: 'WHATSAPP',
        value: '1',
      },
      {
        optionText: 'FACEBOOK',
        value: '2',
      },
      {
        optionText: 'INSTAGRAM',
        value: '3',
      },
      {
        optionText: 'OUTRAS',
        value: '4',
      },
    ],
  },
  {
    questionType: 'TextInput',
    questionText: 'Nome da propriedade:',
    questionId: 'propriedade',
    placeholderText: '',
  },
  {
    questionType: 'NumericInput',
    questionText: 'Produção diária (Média do último mês):',
    questionId: 'producao',
    placeholderText: '',
    maxLength: 5,
  },
  {
    questionType: 'MultipleSelectionGroup',
    questionTypeOriginal: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Faixa de produção',
    questionId: 'faixa_producao',
    options: [
      {
        optionText: '0 - 100',
        value: '0',
      },
      {
        optionText: '100 - 300',
        value: '1',
      },
      {
        optionText: '300 - 500',
        value: '2',
      },
      {
        optionText: '500 - 1000',
        value: '3',
      },
      {
        optionText: '1000 - 2000',
        value: '4',
      },
      {
        optionText: '>2000',
        value: '5',
      },
    ],
  },
  {
    questionType: 'NumericInput',
    questionText: 'CCS (Última análise):',
    questionId: 'ccs',
    placeholderText: '',
    maxLength: 4,
  },
  {
    questionType: 'NumericInput',
    questionText: 'CPP (Última análise):',
    questionId: 'cpp',
    placeholderText: '',
    maxLength: 4,
  },
  {
    questionType: 'MultipleSelectionGroup',
    questionText:
      'Possui outra atividade na propriedade além da produção de leite? (Permitido selecionar várias)',
    questionId: 'outra_atividade',
    questionSettings: {
      autoAdvance: false,
      minMultiSelect: 1,
      maxMultiSelect: 6,
    },
    options: [
      {
        optionText: 'NÃO',
        value: '0',
      },
      {
        optionText: 'CORTE',
        value: '1',
      },
      {
        optionText: 'CAFÉ',
        value: '2',
      },
      {
        optionText: 'SOJA GRÃO',
        value: '3',
      },
      {
        optionText: 'MILHO GRÃO',
        value: '4',
      },
      {
        optionText: 'OUTRAS',
        value: '5',
      },
    ],
  },
  {
    questionType: 'MultipleSelectionGroup',
    questionText:
      'Possui assistência técnica/responsável técnico regular? (Permitido marcar várias)',
    questionId: 'assistencia',
    questionSettings: {
      autoAdvance: false,
      minMultiSelect: 1,
      maxMultiSelect: 9,
    },
    options: [
      {
        optionText: 'NÃO RECEBE',
        value: '0',
      },
      {
        optionText: 'PARTICULAR',
        value: '1',
      },
      {
        optionText: 'LATICÍNIO',
        value: '2',
      },
      {
        optionText: 'EMATER',
        value: '3',
      },
      {
        optionText: 'SENAR',
        value: '4',
      },
      {
        optionText: 'PREFEITURA',
        value: '5',
      },
      {
        optionText: 'BALDE CHEIO',
        value: '6',
      },
      {
        optionText: 'OUTRAS ASSISTÊNCIAS',
        value: '7',
      },
    ],
  },
  {
    questionType: 'MultipleSelectionGroup',
    questionTypeOriginal: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Possui tanque de expansão próprio ou comunitário?',
    questionId: 'tanque',
    options: [
      {
        optionText: 'PRÓPRIO',
        value: '0',
      },
      {
        optionText: 'COMUNITÁRIO',
        value: '1',
      },
    ],
  },
  {
    questionType: 'NumericInput',
    questionText: 'Qual a capacidade do tanque? (Em Litros):',
    questionId: 'capacidade',
    placeholderText: '',
    maxLength: 5,
  },
  {
    questionType: 'MultipleSelectionGroup',
    questionTypeOriginal: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'O leite do tanque é apenas da sua propriedade?',
    questionId: 'tanque_apenas_propriedade',
    options: [
      {
        optionText: 'SIM',
        value: '0',
      },
      {
        optionText: 'NÃO (1 FORNECEDOR)',
        value: '1',
      },
      {
        optionText: 'NÃO (2 FORNECEDORES)',
        value: '2',
      },
      {
        optionText: 'NÃO (3 FORNECEDORES)',
        value: '3',
      },
      {
        optionText: 'NÃO (4 FORNECEDORES)',
        value: '4',
      },
      {
        optionText: 'NÃO (5 OU MAIS FORNECEDORES)',
        value: '5',
      },
    ],
  },
  {
    questionType: 'MultipleSelectionGroup',
    questionTypeOriginal: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Como é o acesso ao tanque de leite da propriedade?',
    questionId: 'acesso_tanque',
    options: [
      {
        optionText: 'BOM',
        value: '0',
      },
      {
        optionText: 'RAZOÁVEL',
        value: '1',
      },
      {
        optionText: 'RUIM',
        value: '2',
      },
      {
        optionText: 'PÉSSIMO',
        value: '3',
      },
    ],
  },
  {
    questionType: 'MultipleSelectionGroup',
    questionTypeOriginal: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText:
      'O local em que o tanque está instalado é adequado (possui acesso apropriado ao veículo coletor, paredes, cobertura, iluminação, ventilação, pavimentação e ponto de água corrente)?',
    questionId: 'local_adequado_tanque',
    agroindustria: '05.646.631/0002-87',
    options: [
      {
        optionText: 'SIM',
        value: '0',
      },
      {
        optionText: 'NÃO',
        value: '1',
      },
      {
        optionText: 'PARCIALMENTE',
        value: '2',
      },
    ],
  },
  {
    questionType: 'MultipleSelectionGroup',
    questionTypeOriginal: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Distância da propriedade ao tanque de resfriamento:',
    questionId: 'distancia_tanque',
    agroindustria: '05.646.631/0002-87',
    options: [
      {
        optionText: 'DENTRO DA PROPRIEDADE',
        value: '0',
      },
      {
        optionText: '0 - 1000 METROS',
        value: '1',
      },
      {
        optionText: '1000 - 5000 METROS',
        value: '2',
      },
      {
        optionText: '5000 - 10000 METROS',
        value: '3',
      },
      {
        optionText: '> 10000 METROS',
        value: '4',
      },
    ],
  },
  {
    questionType: 'MultipleSelectionGroup',
    questionTypeOriginal: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText:
      'Tempo gasto da ordenha até a entrega do leite para resfriamento:',
    questionId: 'tempo_entrega_leite',
    agroindustria: '05.646.631/0002-87',
    options: [
      {
        optionText: '< 1 HORA',
        value: '0',
      },
      {
        optionText: '1 - 2 HORAS',
        value: '1',
      },
      {
        optionText: '2 - 3 HORAS',
        value: '2',
      },
      {
        optionText: '> 3 HORAS',
        value: '3',
      },
    ],
  },
  {
    questionType: 'MultipleSelectionGroup',
    questionTypeOriginal: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Quantas ordenhas são realizadas por dia?',
    questionId: 'ordenhas',
    options: [
      {
        optionText: '1',
        value: '1',
      },
      {
        optionText: '2',
        value: '2',
      },
      {
        optionText: '3',
        value: '3',
      },
    ],
  },
  {
    questionType: 'MultipleSelectionGroup',
    questionTypeOriginal: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Ordenha mecânica ou manual?',
    questionId: 'tipo_ordenha',
    options: [
      {
        optionText: 'MANUAL',
        value: '0',
      },
      {
        optionText: 'MECÂNICA (BALDE AO PÉ)',
        value: '1',
      },
      {
        optionText: 'MECÂNICA (TRANFERIDOR DE LEITE)',
        value: '2',
      },
      {
        optionText: 'MECÂNICA (CIRCUITO FECHADO)',
        value: '3',
      },
    ],
  },
  {
    questionType: 'NumericInput',
    questionText: 'Quantos conjuntos?',
    questionId: 'conjuntos',
    placeholderText: '',
    maxLength: 3,
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Possui gerador de energia na propriedade?',
    questionId: 'gerador_energia',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'MultipleSelectionGroup',
    questionTypeOriginal: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Como é a mão de obra na propriedade?',
    questionId: 'mdo',
    options: [
      {
        optionText: 'FAMILIAR',
        value: '0',
      },
      {
        optionText: 'PATRONAL',
        value: '1',
      },
      {
        optionText: 'FAMILIAR E PATRONAL',
        value: '2',
      },
    ],
  },
  {
    questionType: 'NumericInput',
    questionText:
      'Qual o número de pessoas envolvidas diariamente no manejo do rebanho?',
    questionId: 'num_pessoas_manejo',
    placeholderText: '',
    maxLength: 3,
  },
  {
    questionType: 'MultipleSelectionGroup',
    questionTypeOriginal: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Quantas folgas mensais por funcionário?',
    questionId: 'folgas',
    options: [
      {
        optionText: '1',
        value: '1',
      },
      {
        optionText: '2',
        value: '2',
      },
      {
        optionText: '3',
        value: '3',
      },
      {
        optionText: '4',
        value: '4',
      },
      {
        optionText: '5 OU MAIS',
        value: '5',
      },
      {
        optionText: 'NÃO SE APLICA (MÃO DE OBRA FAMILIAR)',
        value: '0',
      },
    ],
  },
  {
    questionType: 'NumericInput',
    questionText: 'Hoje há quantas vacas em lactação?',
    questionId: 'vacas_lactacao',
    placeholderText: '',
    maxLength: 4,
  },
  {
    questionType: 'NumericInput',
    questionText: 'Hoje há quantas vacas secas?',
    questionId: 'vacas_secas',
    placeholderText: '',
    maxLength: 4,
  },
  {
    questionType: 'NumericInput',
    questionText: 'Hoje há quantos animais no total do rebanho?',
    questionId: 'total_rebanho',
    placeholderText: '',
    maxLength: 5,
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText:
      'Os animais são identificados por brinco ou outro tipo de identificação?',
    questionId: 'identificacao',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Anota partos?',
    questionId: 'anota_partos',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Anota cobertura ou inseminação?',
    questionId: 'anota_inseminacao',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Faz controle leiteiro pelo menos uma vez no mês?',
    questionId: 'controle_leiteiro',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Faz acompanhamento de ganho de peso da recria?',
    questionId: 'acompanhamento_peso',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText:
      'Possui algum sistema de controle zootécnico (Software, Planilha ou APP)?',
    questionId: 'sistema_controle',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Segue algum calendário sanitário de vacinação?',
    questionId: 'calendario_sanitario',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText:
      'Existe algum protocolo específico para bezerra ao nascimento?',
    questionId: 'protocolo_bezerra',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Faz divisão de lotes de vacas em lactação?',
    questionId: 'lote_vacas_lactacao',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Utiliza inseminação artificial?',
    questionId: 'inseminacao_artificial',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Utiliza protocolos de IATF?',
    questionId: 'protocolo_iatf',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'A taxa de mortalidade da cria e recria é baixa?',
    questionId: 'taxa_mortalidade_baixa_cria_recria',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'A infestação por carrapatos é controlada?',
    questionId: 'carrapatos_controlada',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'A incidência de problemas de casco é baixa?',
    questionId: 'problemas_casco_baixa',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Possui protocolos de tratamento de mastite bem definidos?',
    questionId: 'protocolo_mastite',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Incidência de mastite é controlada?',
    questionId: 'incidencia_mastite',
    agroindustria: '05.646.631/0002-87',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Faz separação das vacas em tratamento ou em fase colostral?',
    questionId: 'separacao_vacas_tratamento',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Tem água suficiente para todas as categorias?',
    questionId: 'agua_suficiente',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Anota receitas e despesas?',
    questionId: 'receitas_despesas',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText:
      'Sabe quanto custa o litro de leite produzido na propriedade?',
    questionId: 'custo_litro_leite',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'O ambiente de trabalho é limpo e organizado?',
    questionId: 'ambiente_limpo',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText:
      'A estrutura física da fazenda favorece a realização do serviço?',
    questionId: 'estrutura_realizacao_servico',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'MultipleSelectionGroup',
    questionTypeOriginal: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Qual o sistema de produção adotado?',
    questionId: 'sistema_producao',
    agroindustria: '05.646.631/0002-87',
    options: [
      {
        optionText: 'PASTO',
        value: '0',
      },
      {
        optionText: 'PASTO + SUPLEMENTO EM PARTE DO ANO',
        value: '1',
      },
      {
        optionText: 'PASTO + SUPLEMENTO O ANO TODO',
        value: '2',
      },
      {
        optionText: 'DIETA TOTAL NO COCHO',
        value: '3',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText:
      'Possui volumoso em quantidade suficiente para todo o rebanho durante o ano?',
    questionId: 'volumoso_suficiente',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'O concentrado é misturado na fazenda?',
    questionId: 'concentrado_misturado',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Utiliza silagem de grão rehidratado (Grão Úmido)?',
    questionId: 'grao_umido',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'Faz compra estratégica de insumos (Concentrados e Adubos)?',
    questionId: 'compra_estrategica',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
  {
    questionType: 'SelectionGroup',
    questionSettings: {
      autoAdvance: false,
      allowDeselection: false,
    },
    questionText: 'O manejo de destinação dos dejetos são adequados?',
    questionId: 'manejo_dejetos',
    options: [
      {
        optionText: 'SIM',
        value: '1',
      },
      {
        optionText: 'NÃO',
        value: '0',
      },
    ],
  },
]
